import styled from 'styled-components';
import { space } from 'styled-system';
import { renderToString } from 'react-dom/server';
// helpers/constants
import * as G from '../../helpers';
// svgs
import { zoomPlus, zoomMinus } from '../../svgs';
//////////////////////////////////////////////////

const blackColor = G.getTheme('colors.black');

const encodePlusIcon = encodeURIComponent(renderToString(zoomPlus()));
const encodeMinusIcon = encodeURIComponent(renderToString(zoomMinus()));

const FileViewerWrapper = styled.div`
  ${space}

  height: 100%;
  overflow: hidden;

  & .pg-viewer-wrapper {
    overflow: ${({ disableScroll }: Object) => (disableScroll ? 'hidden' : 'auto')};
  }

  & .react-grid-Container {
    height: 100%;
    margin-left: 0;
  }

  & .pdf-controlls-container {
    width: 80px;
    height: 40px;
    margin: auto;
    display: flex;
    font-size: 30px;
    align-items: flex-start;
    justify-content: space-between;
  }

  & .view-control:nth-child(odd) {
    width: 36px;
    height: 36px;
    cursor: pointer;
    background-size: 70%;
    background-position: center;
    background-repeat: no-repeat;
  }

  & .view-control:nth-child(1) {
    background-image: url('data:image/svg+xml;utf8,${encodePlusIcon}');
  }

  & .view-control:nth-child(3) {
    background-image: url('data:image/svg+xml;utf8,${encodeMinusIcon}');
  }

  & .photo-viewer-container {
    width: auto!important;
    height: auto!important;

    & img {
      width: 100%!important;
      height: auto!important;
    }
  }
`;

const ImageViewerWrapper = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
  background-color: ${blackColor};

  cursor: ${({ isPanning }: Object) => (isPanning ? 'grabbing' : 'grab')};
`;

const ImageUI = styled.img`
  max-width: 100%;
  max-height: 100%;
  user-select: none;
  object-fit: contain;
  pointer-events: none;
  transform-origin: center center;

  transform: ${({ scale, position }: Object) => `translate(${position.x}px, ${position.y}px) scale(${scale})`};
`;

export {
  ImageUI,
  FileViewerWrapper,
  ImageViewerWrapper,
};
